<template>
  <div class="industry_right">
    <!-- o没有权限-->
    <div v-if="!allKey.INDUSTRY_DETAIL" class="noData no_data_container">
      <span class="img no_data_img"></span>
      <p>Sorry, Do not have permission</p>
    </div>

    <div v-else class="industry_right_container">
      <span
        :class="favouriteStatus ? 'isFavorite' : 'isNFavorite'"
        class="favourite_btn"
        @click="setFavouriteStatus"
      ></span>
      <span class="home-btn" @click="setIndexShow"></span>

      <p class="company_common_title">
        <span>{{ industryTitle }}</span>
      </p>

      <!-- Index name --><!-- Revised on 2022-05-24 -->
      <div class="contai" style="display:none;">
        <title-temp title="Index name"></title-temp>
        <div class="tag_list">
          <!-- <span v-for="(item,index) of currentCheckedAll" :key="index">{{Conver(item).name}}</span> -->
          <el-tag
            :key="index"
            v-for="(item, index) of currentCheckedAll"
            closable
            :disable-transitions="false"
            @close="handleClose(item)"
          >{{ Conver(item).name }}</el-tag>
        </div>
        <div class="btnContainer">
          <el-button @click="reset">Reset</el-button>
          <el-button type="primary" @click="searchResult">Display</el-button>
        </div>
      </div>

      <!-- Chart display -->
      <div class="chart-contai contai" v-if="refushChart">
        <title-temp title="Chart display"></title-temp>
        <!-- <el-date-picker
          v-model="datePicker"
          type="daterange"
          start-placeholder="Start Date"
          end-placeholder="End Date"
          align="right"
          value-format="yyyy-MM-dd"
          @change="searchResultChart"
        ></el-date-picker>-->
        <!--  -->
        <el-date-picker
          class="search-chart"
          v-model="datePickerDouble.startDate"
          type="date"
          size="mini"
          value-format="yyyy-MM-dd"
          placeholder="Start Date"
          :picker-options="pickerOptionsStart"
        ></el-date-picker>
        <el-date-picker
          class="search-chart"
          v-model="datePickerDouble.endDate"
          type="date"
          size="mini"
          value-format="yyyy-MM-dd"
          placeholder="End Date"
          :picker-options="pickerOptionsEnd"
        ></el-date-picker>
        <el-button
          style="width: 28px;height: 28px;"
          type="primary"
          icon="el-icon-search"
          circle
          size="mini"
          :disabled="!dateSearchDisabled"
          @click="searchResult"
        ></el-button><!-- Revised on 2022-05-24 -->
        <!--  -->
        <line-chart
          :xData="xData"
          :serData="serData"
          v-loading="loadingChart"
          element-loading-spinner="fa fa-spinner fa-pulse fa-2x mt-3"
        ></line-chart>
      </div>

      <!-- search result -->
      <div class="downContainer contai" style="height:calc(100% - 342px)">
        <!-- Revised on 2022-05-24 -->
        <el-button
          type="text"
          class="downLoadBtn paddingBtn"
          @click="downLoadFn()"
          v-if="allKey.INDUSTRY_DOWNLOAD"
        >
          <i class="el-icon-download"></i>
          download
        </el-button>
        <title-temp title="Search results"></title-temp>
        <table-list
          :column="currentColumn"
          :tableData="currentData"
          :column200="true"
          v-loading="loadingTable"
          :showNumber="false"
          element-loading-spinner="fa fa-spinner fa-pulse fa-2x mt-3"
        ></table-list><!-- Revised on 2022-05-24 -->
      </div>
    </div>
  </div>
</template>

<script>
import TitleTemp from "common/components/Title";
import TableList from "./components/table1";// <!-- Revised on 2022-05-24 -->
import LineChart from "./components/BarLine";
import column from "conf/industrySearchIndex";// <!-- Revised on 2022-05-24 -->
import { mapState, mapMutations } from "vuex";
import {
  getIndictorsData,
  postSaveFavourite,
  getFavouriteDetail
} from "common/js/http/v2Api";
import {
  get_query_node_info,
  get_query_node_value
} from "common/js/http/v3Api";// <!-- Revised on 2022-05-24 -->
const color = [
  "#836FFF",
  "#71C671",
  "#5E71FF",
  "#86C1FF",
  "#7583EA",
  "#FFC962",
  "#BCD2EE",
  "#A2B5CD",
  "#FFC125",
  "#757575"
];

export default {
  components: {
    TitleTemp,
    TableList,
    LineChart
  },

  data() {
    return {
      industryTitle: "Industry search index",
      currentColumn: column,
      currentData: [],
      xData: [],
      serData: [],
      datePicker: [],
      refushChart: true,
      workerTable: null,

      favouriteStatus: false,
      favouriteId: null,
      userId: parseInt(this.Cookies.get("imsilkroad_userid")),
      // userId: 1,
      loadingChart: false,
      loadingTable: false,
      // 日期
      datePickerDouble: {
        startDate: "",
        endDate: ""
      },
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.datePickerDouble.endDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.datePickerDouble.startDate;
          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
            );
          }
        }
      },
      currNodeCode: '',
      flag: true
    };
  },

  computed: {
    ...mapState({
      currentCheckedAll(state) {
        // <!-- Revised on 2022-05-24 -->
        if (state.IndustyChecked.treeChecked && state.IndustyChecked.treeChecked.length > 0 && state.IndustyChecked.treeChecked[0].NodeCode && this.currNodeCode != state.IndustyChecked.treeChecked[0].NodeCode) {
          this.currNodeCode = state.IndustyChecked.treeChecked[0].NodeCode
          if (this.flag) {
            this.flag = false
            this.searchResult()
            setTimeout(() => {
              this.flag = true
            }, 1000)
          }
        }

        return state.IndustyChecked.treeChecked
        // state.IndustyChecked.ListChecked.concat(
        //   state.IndustyChecked.treeChecked
        // );
      },

      refush(state) {
        return state.ChartRefush.refush;
      },

      allKey(state) {
        return state.v2Permission.v2CurrentPermission;
      }
    }),

    dateSearchDisabled() {
      return (
        !!this.datePickerDouble.startDate && !!this.datePickerDouble.endDate
      );
    }
  },

  created() {
    if (this.$route.query.id) {
      // alert(this.$route.query.id);
      this.getFavoriteDetailById(this.$route.query.id);
    }
  },

  methods: {
    //有id回显数据
    async getFavoriteDetailById(id) {
      const { result } = await getFavouriteDetail(id);
      if (result) {
        const list = JSON.parse(result.params).indictors;
        const Jsonlist = list.map(item => JSON.stringify(item));
        this.setListChecked(Jsonlist);
        this.searchResult();
      }
    },

    Conver(item) {
      if (typeof item == "string") {
        return JSON.parse(item);
      } else return item;
    },

    handleClose(item) {
      if (typeof item == "string") {
        const id = JSON.parse(item).id;
        this.deleteListed(id);
      } else {
        this.deleteTree(item.id);
      }
    },

    async searchResult() {
      this.loadingChart = true;
      this.loadingTable = true;
       // <!-- Revised on 2022-05-24 -->
      const { data } = await get_query_node_info({ "NodeCode": this.currNodeCode });
      if (data != null && data.length > 0) {
        if (localStorage.getItem('queryNodeDetail')) {
          var list = JSON.parse(localStorage.getItem('queryNodeList'));
          let that = this;
          let iscode = false;
          list.forEach(item=>{
            if (item.NodeCode == that.currNodeCode) {
              setTimeout(() => {
                that.converChartData(item.ChartData);
              }, 0);
              setTimeout(() => {
                that.converTableData(item.TableData);
              }, 0);
              return
            } else {
              iscode = true;
            }
          })
          if (iscode) {
            const value = await get_query_node_value({ "NodeCode": this.currNodeCode,"pageNo": "1","pageSize": "99999999",'sdate':this.datePickerDouble.startDate,"edate":  this.datePickerDouble.endDate});
            // console.log(value)
            if (value != null && value.data.length > 0) {
              const obj = value.data.sort(sortDownDate);
              function sortDownDate(a,b) {
                return Date.parse(a.UpdateTime) - Date.parse(b.UpdateTime)
              }
              obj.map(item => {
                item.IndicatorName = data[0].IndicatorName
              })
              setTimeout(() => {
                this.converChartData(obj.reverse());
              }, 0);
              setTimeout(() => {
                this.converTableData(obj.reverse());
              }, 0);
              list.push({NodeCode: this.currNodeCode, ChartData: obj,TableData: obj.reverse()})
              localStorage.setItem('queryNodeList', JSON.stringify(list))
            } else {
              this.$message({
                message: '没有查询到相关信息！',
                type: 'warning'
              });
            }
          }
        } else {
          const value = await get_query_node_value({ "NodeCode": this.currNodeCode,"pageNo": "1","pageSize": "99999999",'sdate':this.datePickerDouble.startDate,"edate":  this.datePickerDouble.endDate});
          // console.log(value)
          if (value != null && value.data.length > 0) {
            const obj = value.data.sort(sortDownDate);
            function sortDownDate(a,b) {
              return Date.parse(a.UpdateTime) - Date.parse(b.UpdateTime)
            }
            obj.map(item => {
              item.IndicatorName = data[0].IndicatorName
            })
            setTimeout(() => {
              this.converChartData(obj.reverse());
            }, 0);
            setTimeout(() => {
              this.converTableData(obj.reverse());
            }, 0);
            localStorage.setItem('queryNodeList', JSON.stringify([{NodeCode: this.currNodeCode, ChartData: obj,TableData: obj.reverse()}]));//重点在这里
            localStorage.setItem("queryNodeDetail",true)
          } else {
            this.$message({
              message: '没有查询到相关信息！',
              type: 'warning'
            });
          }
        }
      }
      // const indictors = this.currentCheckedAll.map(item => ({
      //   id: item.id || JSON.parse(item).id
      // }));
      // const params = {
      //   indictors
      // };
      // if (!params.indictors.length) return;

      // //清空时间
      // this.datePickerDouble.startDate = "";
      // this.datePickerDouble.endDate = "";

      // this.loadingChart = true;
      // this.loadingTable = true;

      // const { result } = await getIndictorsData(params);
      // // this.creatWorkerConverTable(result);
      // setTimeout(() => {
      //   this.converTableData(result);
      // }, 0);
      // setTimeout(() => {
      //   this.converChartData(result);
      // }, 0);
    },

    async searchResultChart() {
      const indictors = this.currentCheckedAll.map(item => ({
        id: item.id || JSON.parse(item).id
      }));
      const params = {
        indictors
      };
      if (!params.indictors.length) return;

      // if (this.datePicker && this.datePicker.length == 2) {
      //   params.startTime = this.datePicker[0];
      //   params.endTime = this.datePicker[1];
      // }
      params.startTime = this.datePickerDouble.startDate;
      params.endTime = this.datePickerDouble.endDate;

      const { result } = await getIndictorsData(params);
      // setTimeout(() => {
      //   this.converTableData(result);
      // }, 0);
      setTimeout(() => {
        this.converChartData(result);
      }, 0);
    },

    //webworker可用版本
    creatWorkerConverTable(result1) {
      const result = this.$lodash.cloneDeep(result1);
      const columnCf = this.$lodash.cloneDeep(column);
      const $moment = this.$moment;

      this.workerTable = this.$worker
        .run(
          (result, columnCf) => {
            const data = result.map(item => {
              const itemData = {
                name: item.name,
                location: item.location,
                time: item.time,
                unit: item.unit,
                resource: item.resource
              };
              item.data.reverse().forEach(i => {
                const dateKey = i.moditime.includes("T")
                  ? i.moditime.split("T")[0] //vue-worker无法传递函数,截取代替moment.js
                  : i.moditime;
                columnCf.push({
                  label: dateKey,
                  field: dateKey
                });
                itemData[dateKey] = i.value;
              });
              return itemData;
            });
            return {
              columnCf,
              data
            };
          },
          [result, columnCf]
        )
        .then(res => {
          this.currentColumn = res.columnCf;
          this.currentData = res.data;
          this.loadingTable = false;
        });
    },

    //行业 顺序是升序 需要reverse table
    converTableData(result1) {
      const result = this.$lodash.cloneDeep(result1);
       // <!-- Revised on 2022-05-24 -->
      const columnCf = this.$lodash.cloneDeep(column);
      const data = result.map(item => {
        const itemData = {
          IndicatorName: item.IndicatorName,
          IndicatorCode: item.IndicatorCode,
          DataValue: item.DataValue,
          UpdateTime: item.UpdateTime ? item.UpdateTime.split(" ")[0] : "",
          BeginDate: item.BeginDate ? item.BeginDate.split(" ")[0] : "",
          EndDate: item.EndDate ? item.EndDate.split(" ")[0] : "",
        };
        // item.data.reverse().forEach(i => {
        //   const dateKey = this.$moment(i.moditime).format("YYYY-MM-DD");
        //   columnCf.push({
        //     label: dateKey,
        //     field: dateKey
        //   });
        //   itemData[dateKey] = i.value;
        // });
        return itemData;
      });
      // 设置列
      this.currentColumn = columnCf;

      this.currentData = data;

      this.loadingTable = false;
    },

    converChartData(result1) {
       // <!-- Revised on 2022-05-24 -->
      const resultClone = this.$lodash.cloneDeep(result1);
      const result = []
      const tmpArr = []
      resultClone.map(item => {
        tmpArr.push({
          moditime: item.UpdateTime,
          value: item.DataValue
        })
      })
      result.push({ name: resultClone[0].IndicatorName, data: tmpArr })

      const data = result.map((item, index) => {
        const x_data = [];
        let unit = item.unit ? "(Unit:" + item.unit + ")" : "";
        const itemData = {
          name: item.name + unit,
          type: "line",
          // stack: "dta",
          data: [],
          unit: item.unit,
          smooth: true,
          itemStyle: {
            normal: {
              color: color[index % 10], //改变折线点的颜色
              lineStyle: {
                color: color[index % 10] //改变折线颜色
              }
            }
          }
        };
        item.data.forEach(i => {
          const dateKey = this.$moment(i.moditime).format("YYYY-MM-DD");
          x_data.push(dateKey);
          itemData.data.push(i.value || 0);
        });
        this.xData = x_data;
        this.loadingChart = false;
        return itemData;
      });

      const isLength = data.filter(item => item.data.length);
      this.serData = isLength.length ? data : [];
      this.loadingChart = false;
    },

    reset() {
      this.industryReset();
      //修复bug标记 02
      this.currentData = [];
      this.serData = [];
      //
    },

    downLoadFn() {
      let result = "";
      let dataArray = [];
      dataArray = [...this.currentColumn.map(item => item.label)];

      result = dataArray.join(",") + `\n`; //先遍历得到表头信息

      this.currentData.forEach(item => {
        this.currentColumn.forEach(itemColumn => {
          result += `${item[itemColumn.field] + "\t"},`;
        });
        result += "\n";
      });

      //encodeURIComponent解决中文乱码
      let uri =
        "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(result);
      //通过创建a标签实现
      var link = document.createElement("a");
      link.href = uri;
      //对下载的文件命名
      link.download = `Industry Search results.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    setFavouriteStatus() {
      //准备收藏
      if (!this.favouriteStatus) {
        let url = window.location.href;
        // module收藏数据类型 1 企业 2 并购 3 行业 4 指标
        let params = {
          module: 3,
          params: {},
          title: "",
          userId: this.userId,
          url: url.split("?")[0]
        };

        const indictors = this.currentCheckedAll.map(item => ({
          id: item.id || JSON.parse(item).id,
          name: item.name || JSON.parse(item).name,
          time: item.time || JSON.parse(item).time
        }));
        const paramsIndictors = {
          indictors
        };
        if (!paramsIndictors.indictors.length) {
          // Can't be empty
          this.$message({
            message: "Index name Cannot be empty!",
            type: "warning"
          });
          return;
        }

        params.params = JSON.stringify(paramsIndictors);

        this.$prompt("Please enter a title", "Notice", {
          confirmButtonText: "sure",
          cancelButtonText: "cancle"
        }).then(({ value }) => {
          params.title = value;
          this.saveFavorite(params);
        });
      }

      // this.favouriteStatus = !this.favouriteStatus;
    },

    //收藏
    async saveFavorite(params) {
      const { result } = await postSaveFavourite(params);
      // Collection of success
      this.$message({
        message: "Collection of success!",
        type: "success"
      });
    },

    setIndexShow() {
      this.changeIndexShow(true);
    },

    ...mapMutations([
      "deleteListed",
      "deleteTree",
      "industryReset",
      "setListChecked",
      "changeIndexShow"
    ])
  },

  watch: {
     // <!-- Revised on 2022-05-24 -->
    currentCheckedAll: {
      handler(newVal, oldVal) {
        // console.log("TCL: treeChecked -> 1111111111", newVal);
      },
      deep: true
    },
    treeChecked(newValue) {
      // console.log("TCL: treeChecked -> 22222", newValue);
    },
    refush(newValue) {
      // console.log("TCL: refush -> newValue", newValue);
      // this.refushChart = false;
      // this.$nextTick(() => {
      //   this.refushChart = true;
      // });
    }
  }
};
</script>

<style scoped>
.industry_right {
  height: 100%;
  /* padding: 20px; */
}
.tag_list span {
  border: 1px solid #e2e3e4;
  border-radius: 15.5px;
  /* padding: 5px 10px; */
  margin-right: 10px;
  margin-bottom: 10px;
}
.tag_list {
  border: 1px solid #f3f4f5;
  height: 100px;
  overflow: auto;
  padding: 10px;
}
.btnContainer {
  text-align: right;
  margin-top: 20px;
}
.chart-contai >>> .el-date-editor .el-range-separator {
  line-height: 25px;
}
.chart-contai >>> .el-date-editor .el-range__close-icon {
  line-height: 27px;
}
.downContainer {
  position: relative;
}
.downLoadBtn {
  position: absolute;
  right: 0px;
  top: 40px;
}
.industry_right_container {
  position: relative;
  height: 100%;
}
.favourite_btn {
  /* top: 0px !important; */
}
.search-chart {
  margin-right: 10px;
}
.contai {
  padding: 10px;
}
</style>
